import { STATUS_META } from "@/lib/constants";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

const ICONS = {
  eligible: CheckCircle2,
  potentially_eligible: AlertTriangle,
  not_eligible: XCircle,
};

export function StatusBadge({ status, size = "md", testId }) {
  const meta = STATUS_META[status] || STATUS_META.not_eligible;
  const Icon = ICONS[status] || XCircle;
  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad}`}
      style={{ color: meta.color, backgroundColor: meta.bg, borderColor: meta.border }}
    >
      <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {meta.label}
    </span>
  );
}
